<app-main-navbar [wipperozLogo]="wipperozLogo" [navbarClass]="'navbar-color-white'"></app-main-navbar>
<div
  class="wipperoz-main-banner"
  [ngStyle]="{ 'background-image': 'url(' + content.featureImageUrl + '?fm=webp&q=90&w=1920&h=1080' + ')' }"
>
  <div class="container">
    <div class="wipperoz-main-content">
      <div class="single-banner-boxes-service">
        <h1>{{ content.contentTitle }}</h1>
        <h2>
          {{ content.contentDescription }}
        </h2>
        <a [href]="urlSignUp" target="_blank" class="btn btn-primary" i18n="@@getStartedButton">Get started</a>
      </div>
    </div>
    <div class="single-banner-boxes-service">
      <div [innerHtml]="content.content | safeHtml"></div>
    </div>
  </div>
  <app-wip-steps></app-wip-steps>
</div>
<app-pricing></app-pricing>
<app-feedback></app-feedback>
<app-join-today></app-join-today>
<app-recent-blog-articles></app-recent-blog-articles>
<div class="footer">
  <app-footer [showGoogle]="false"></app-footer>
</div>
